import { render, staticRenderFns } from "./increaseLand.vue?vue&type=template&id=965a23ac&scoped=true"
import script from "./increaseLand.vue?vue&type=script&lang=js"
export * from "./increaseLand.vue?vue&type=script&lang=js"
import style0 from "./increaseLand.vue?vue&type=style&index=0&id=965a23ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965a23ac",
  null
  
)

export default component.exports